import { UploadFile } from 'antd/es/upload/interface';
const getFileExtension = (filename: string) => {
  let ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? '' : ext[1].toLowerCase();
};
const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

const downloadFileToDevice = (data: any, name: string) => {
  let a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  const blob = new Blob([data], {
      type: 'application/octet-stream',
    }),
    url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = name;
  a.click();
  window.URL.revokeObjectURL(url);
};

const viewFileInNewTab = (data: any, type?: string, newTab?: any) => {
  const fileURL = URL.createObjectURL(
    new Blob([new Uint8Array(data)], { type })
  );
  window.open(fileURL);
};

const getExtensionFile = (fileName?: string) => {
  return fileName
    ? fileName
        .split('.')
        .pop()
        ?.toLowerCase()
    : '';
};

// check type includes extension of file
const checkType = (img: UploadFile, type: string[]) => {
  const typeFile = getExtensionFile(img.fileName || img.name);
  if (typeFile && type.includes(typeFile)) return true;
  return false;
};

export default {
  getFileExtension,
  getBase64,
  downloadFileToDevice,
  getExtensionFile,
  viewFileInNewTab,
  checkType,
};
